import { combineReducers } from "redux";
import { UserDataReducer } from "./DataReducer";
const reducers = combineReducers({
  UserData: UserDataReducer,
});
export default reducers;
